module.exports = __webpack_public_path__ + "static/media/4.e851f5d9.JPG";